export class projectCostSearchFactory{

months: string[] = [];


    search(){
        let searchBody = {
            month:null,
            months:this.months,
        }
        return searchBody
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/factories/project-cost/project-cost.search.factory.ts